export default __webpack_public_path__ + "static/media/collapse-usage-1.1d2c5155.svg";